import { FunctionComponent } from 'react'
import Icon from '@/components/HeroIcons'
import { RenderIf } from '@/components/RenderIf'
import { ISpecialtyResponse } from '../../auth-types'
import useStyles from './user-profile-card-details-style'
import { Box, Avatar, Text, Tooltip } from '@conexasaude/conexa-hero'

interface PropsUserProfileCardDetails {
  className?: string
  name: string
  busy: boolean
  token: string
  clinic: string
  photo: string
  type: string
  specialities: Record<string, ISpecialtyResponse>
  onClick(): void
}

const UserProfileCardDetails: FunctionComponent<
  PropsUserProfileCardDetails
> = ({ onClick, className, busy, name, clinic, specialities, photo }) => {
  const styles = useStyles()

  const specialitiesArray = [
    specialities.socialWorker,
    specialities.dentist,
    specialities.nursing,
    specialities.physiotherapy,
    specialities.speechTherapist,
    specialities.nutrition,
    specialities.psyAlive,
    specialities.psychology,
  ]

  return (
    <div className={className} css={styles.userProfileCard}>
      <Box background="primary">
        <div css={styles.itemsCard}>
          <div>
            <div css={styles.cardWrapper}>
              <div css={styles.avatarCard}>
                <Avatar alt={name} size="medium" src={photo} />
              </div>
              <div>
                <Text variant="headingSmall" css={styles.nameCard}>
                  {name.toLowerCase()}
                </Text>
                <div css={styles.clinicCard}>{clinic}</div>
              </div>
            </div>
            <div css={styles.textCard}>
              <Text renderAs="p">Especialidades disponíveis nesta conta</Text>
            </div>
            <div css={styles.specialityCard}>
              <RenderIf condition={specialities?.medic?.atendimentoImediato}>
                <Tooltip
                  label="Você pode realizar consulta imediata com clínico geral, para te ajudar no momento que precisar."
                  position="bottom-start"
                  width={200}
                  multiline
                  withArrow
                >
                  <p>Atendimento Imediato</p>
                </Tooltip>
              </RenderIf>
              <RenderIf condition={specialities?.medic?.atendimentoAgendado}>
                <Tooltip
                  label="Você pode agendar consultas com clínicos gerais e especialistas,  para cuidar da saúde por completo."
                  position="bottom-start"
                  width={200}
                  multiline
                  withArrow
                >
                  <p>Médicos</p>
                </Tooltip>
              </RenderIf>
              {specialitiesArray?.map(speciality => (
                <RenderIf
                  key={speciality?.id}
                  condition={speciality?.habilitado}
                >
                  <Tooltip
                    label={speciality?.descricaoServico}
                    position="bottom-start"
                    width={200}
                    multiline
                    withArrow
                  >
                    <p>{speciality?.descricaoGeral}</p>
                  </Tooltip>
                </RenderIf>
              ))}
            </div>
          </div>
          <div css={styles.iconCard}>
            {busy ? (
              <Icon name="loading" width={'24px'} height={'24px'} />
            ) : (
              <Icon
                name="arrow-group"
                width={'24px'}
                height={'24px'}
                onClick={() => onClick()}
              />
            )}
          </div>
        </div>
      </Box>
    </div>
  )
}

export default UserProfileCardDetails
